<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Befm3V/tc-custom/9781467452540.jpg?1730408925845" alt="This image is the cover for the book Jesus according to the New Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jesus according to the New Testament
      </h1>
      <p class="bookDescription body article font2">
        <p>New Testament scholar James D. G. Dunn has published his research on Christian origins in numerous commentaries, books, and essays. In this small, straightforward book designed especially for a lay audience, Dunn focuses his fifty-plus years of scholarship on elucidating the New Testament witness to Jesus, from Matthew to Revelation. Dunn’s <i>Jesus according to the New Testament </i>constantly points back to the wonder of those first witnesses and greatly enriches our understanding of Jesus.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James D. G. Dunn, Rowan Williams
      </h2>
      
      <p class="authorDescription body article">&#160;<B>James D. G. Dunn</B>&#160;(1939&ndash;2020) was a renowned New Testament scholar and the longtime Lightfoot Professor of Divinity at Durham University. His numerous books include&#160;<I>The Theology of Paul the Apostle</I>,&#160;<I>Jesus according to the New Testament</I>, and the magisterial&#160;<I>Christianity in the Making</I>&#160;trilogy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e3b3969